module.exports = __webpack_public_path__ + "img/00030.ace77e40.webp";